import { constructCategoryFacet } from '@obeta/utils/lib/search/facets'
import { ArticleSearchParamsWithId } from '@obeta/models/lib/models/Search'
import { buildSearchParams } from './useArticleSearch'

export const useSearchFacets = (searchParams: ArticleSearchParamsWithId) => {
  const transformedSearchParams = buildSearchParams(searchParams, true)

  // categories
  const obetaCategoryFacets = constructCategoryFacet(
    transformedSearchParams.obetaCategory?.level,
    'obetaCatalogIds'
  ).facets
  const dehaCategoryFacets = constructCategoryFacet(
    transformedSearchParams.dehaCategory?.level,
    'dehaCatalogIds'
  ).facets

  return Array.from(
    new Set([
      'type',
      'warehouseAvailability.warehouse_10',
      'warehouseAvailability.warehouse_500',
      'supplierFilterName',
      'obetaCatalogIds.lvl0',
      'dehaCatalogIds.lvl0',
      'eligibleFor',
      'zEtimData.class.id', //  TODO check if searchToFilterProducts can use the facet from useArticleSearch response, since hitsPerPage are different
      'listPrice', //  TODO check if searchToFilterProducts can use the facet from useArticleSearch response, since hitsPerPage are different
      ...obetaCategoryFacets,
      ...dehaCategoryFacets,
    ])
  )
}
